import { TimesheetPageCycleFragment } from 'generated/resources/graphql'
import moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'

type AttendanceCycle = TimesheetPageCycleFragment

class AttendanceCyclesUtils {
  static lastCycle = (cycles: Pick<AttendanceCycle, 'startDate' | 'endDate'>[]) => {
    return cycles.at(-1)
  }

  static openPeriod = (cycles: Pick<AttendanceCycle, 'startDate' | 'endDate'>[]) => {
    return cycles.some((cycle) =>
      moment().isBetween(
        stringToDate(cycle.startDate, 'backend'),
        stringToDate(cycle.endDate, 'backend'),
        'day',
        '[]'
      )
    )
  }
}

export default AttendanceCyclesUtils
